module.exports = __webpack_public_path__ + "assets/31e7deec8fcac8c999a6618908f0ba77.png";